// useConfirmDialog.js
import { useState, useCallback } from "react";

export const useConfirmDialog = () => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState({
    title: "Confirm",
    content: "Are you sure?",
    confirmText: "Yes",
    cancelText: "Cancel",
    onConfirm: () => {},
    onCancel: () => setOpen(false),
  });

  const showDialog = useCallback((opts = {}) => {
    setOptions((prev) => ({ ...prev, ...opts }));
    setOpen(true);
  }, []);

  const handleConfirm = useCallback(() => {
    if (options.onConfirm) options.onConfirm();
    setOpen(false);
  }, [options]);

  const handleCancel = useCallback(() => {
    if (options.onCancel) options.onCancel();
    setOpen(false);
  }, [options]);

  return {
    open,
    options,
    showDialog,
    handleConfirm,
    handleCancel,
    setOpen,
  };
};